export const memberTicketPaymentKeys = {
    all: ['memberTicketPayment'] as const,
    list: (centerId: string) => [...memberTicketPaymentKeys.all, 'list', centerId] as const,
    detail: (paymentId: string) => [...memberTicketPaymentKeys.all, 'detail', paymentId] as const,
};
